import { Linkedin, EnvelopeFill } from 'react-bootstrap-icons';
import React, { useState, useEffect } from "react";

const Jumbotron = () => {
    const [showEmail, setShowEmail] = useState(false);
    const [hasClicked, setHasClicked] = useState(false);

    useEffect(() => {
        let timer;
        if (showEmail) {
            timer = setTimeout(() => {
                setShowEmail(false);
            }, 6000);
        }
        return () => clearTimeout(timer);
    }, [showEmail]);

    const handleEmailClick = () => {
        setShowEmail(true);
        setHasClicked(true);
    };
    return (
        <section className="jumbotron text-center">
                        <img
                        src="img/1656345570288.jpg"
                        alt="Giovanni Abel"
                        width="200"
                        className="rounded-circle img-thumbnail"
                        />
                        <h1 className="display-4 lineRight">Giovanni Abel Christian</h1>
                        <p className="lead lineLeft">
                        AI Engineer | Data Scientist
                        </p>
                        <hr className="mx-auto" style={{ width: '600px' }} />
                        <div className="row">
                        <div className="col lineUp">
                            <div className="iconatas mx-auto">
                            <a href='https://www.linkedin.com/in/giovanni-abel-a7145a22b/'  target="_blank" className='p-2' rel="noopener noreferrer"
                            >
                                <Linkedin className="icons_edit" size={30}/>
                            </a>
                            {/* <a href="https://github.com/giovanniabel" target="_blank" styles="color: #000; text-decoration: none">
                                <i className="fab fa-github fa-2x fa-fw icons_edit"></i>
                            </a>  */}
                            <i
                                style={{ color: '#000000', textDecoration: 'none', cursor: 'pointer' }}
                                onClick={handleEmailClick}
                            >
                                <EnvelopeFill className="icons_edit" size={34} />
                            </i>
                            <p
                                className="tultip mt-2 fw-semibold"
                                style={{
                                    opacity: showEmail ? 1 : 0, 
                                    pointerEvents: 'none',
                                    animation: showEmail 
                                        ? "3s anim-Appear ease-out" 
                                        : (hasClicked ? "2s anim-disAppear ease-out forwards" : "none")
                                }}
                            >
                                giovanniabel@outlook.com
                            </p>
                            </div>
                        </div>
                        </div>
        </section>
    )

}

export default Jumbotron;